import React from "react";
import "./CareCoins.styles.scss";

import { DEFAULT_CARE_COINS } from "../../data/drugOptionsV2";
import Card from "../../atoms/CardV2/Card";
import Button from "../../atoms/Button/Button";
import { RiCoinFill } from "react-icons/ri";

interface CareCoinsProps {
  isRewardsAssign: boolean;
  disabled: boolean;
  addedCareCoins: number;
  handleAddCareCoins: () => void;
  handleRemoveCareCoins: () => void;
}

const CareCoins: React.FC<CareCoinsProps> = ({
  isRewardsAssign,
  disabled,
  addedCareCoins,
  handleAddCareCoins,
  handleRemoveCareCoins,
}) => {
  return (
    <Card
      titleIcon={<RiCoinFill size={24} />}
      title="Care coins"
      footer={
        <Button
          onClick={isRewardsAssign ? handleRemoveCareCoins : handleAddCareCoins}
          disabled={disabled}
        >
          {isRewardsAssign ? "Remove" : "Add"}
        </Button>
      }
    >
      <div className="new-care-coin-content">
        {isRewardsAssign
          ? `${addedCareCoins} care coins added to patient wallet`
          : `Add ${DEFAULT_CARE_COINS} care coins to patient wallet`}
      </div>
    </Card>
  );
};

export default CareCoins;
